import { Box, Typography, styled } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import { useSelector } from "react-redux";

function TradePrices({ coinMarketDetails }) {
  const brokerInfo = useSelector((state) => state.wallet.brokerInfo?.data)

  return (
    <>
      <PriceBox>
        <Typography fontWeight={400} color="text.main" variant="subtitle2">
          Buy
        </Typography>
        <Detail color="success.main">
          <TypographyStyle variant="span" fontWeight={700}>
            <NumberFormats value={coinMarketDetails?.priceBuy} />
          </TypographyStyle>
        </Detail>

        <Typography fontWeight={400} color="text.main" variant="subtitle2">
          Sell
        </Typography>
        <Detail color="error.main">
          <TypographyStyle variant="span" fontWeight={700}>
            <NumberFormats value={coinMarketDetails?.priceSell} />
          </TypographyStyle>
        </Detail>
      </PriceBox>

      <PriceBox>
        <Typography fontWeight={400} color="text.main" variant="subtitle2">
          Total Buy
        </Typography>
        <Detail color="success.main">
          <TypographyStyle variant="span" fontWeight={700}>
            <NumberFormats value={brokerInfo?.buyTotalPositionUSDT} />
          </TypographyStyle>
        </Detail>

        <Typography fontWeight={400} color="text.main" variant="subtitle2">
          Total Sell
        </Typography>
        <Detail color="error.main">
          <TypographyStyle variant="span" fontWeight={700}>
            <NumberFormats value={brokerInfo?.sellTotalPositionUSDT} />
          </TypographyStyle>
        </Detail>

        <Typography fontWeight={400} color="text.main" variant="subtitle2">
          Available USDT
        </Typography>
        <Detail color="text.main">
          <TypographyStyle variant="span" fontWeight={700}>
            <NumberFormats value={brokerInfo?.allTotalPositionUSDT} />
          </TypographyStyle>
        </Detail>
      </PriceBox>
    </>
  );
}

const PriceBox = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(1),
  marginRight: theme.spacing(0.2),
  boxShadow: `0 0 5px 2px ${theme.palette.background.boxShadowPrices}`,
  border: `1px solid ${theme.palette.common.white}10`,
  padding: theme.spacing(1.5),
  borderRadius: "8px",
}));

const Detail = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

const TypographyStyle = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

export default TradePrices;
